/**
 * Product gallery: variant → photo strip sync.
 * When product-sync.js changes the hero image src (variant selection),
 * the MutationObserver updates which photo strip thumbnail is active.
 *
 * Click-to-swap is handled by the inline script in product-main.liquid.
 */
(function () {
  'use strict';

  var mainImage = document.querySelector('[data-gallery-image]');
  var thumbContainer = document.querySelector('[data-photos-strip]');

  if (!mainImage || !thumbContainer) return;

  var thumbs = thumbContainer.querySelectorAll('[data-photo-swap]');
  if (thumbs.length === 0) return;

  /* Sync active thumb when main image changes (from variant selection) */
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === 'src') {
        var currentSrc = mainImage.src;
        thumbs.forEach(function (thumb) {
          thumb.classList.remove('is-active');
          var thumbSrc = thumb.getAttribute('data-src');
          /* Compare filename portion to handle CDN URL differences */
          if (thumbSrc && extractBase(thumbSrc) === extractBase(currentSrc)) {
            thumb.classList.add('is-active');
          }
        });
        break;
      }
    }
  });

  observer.observe(mainImage, { attributes: true, attributeFilter: ['src'] });

  function extractBase(url) {
    if (!url) return '';
    var parts = url.split('/');
    return parts[parts.length - 1].split('?')[0];
  }

  /* ── Filter the strip to the selected colour ──
     Each thumb carries the colours it is assigned to in Shopify, pipe separated, and
     an empty value means assigned to none. A thumb is hidden only when it belongs to
     a DIFFERENT colour: unassigned shots stay, because Shopify records just one
     featured image per variant, so hiding the unassigned ones would strip most
     products down to a single photo. */
  var colorIndex = parseInt(thumbContainer.getAttribute('data-color-index'), 10) || 0;

  function colorsOf(thumb) {
    var raw = thumb.getAttribute('data-colors') || '';
    return raw.split('|').filter(Boolean);
  }

  function filterToColor(color) {
    if (!colorIndex || !color) return;

    var firstVisible = null;
    var firstOfColor = null;
    var hidden = 0;

    thumbs.forEach(function (thumb) {
      var owns = colorsOf(thumb);
      /* Unassigned (owns.length === 0) is shared, so it survives every filter. */
      var show = owns.length === 0 || owns.indexOf(color) !== -1;
      thumb.hidden = !show;
      if (show) {
        if (!firstVisible) firstVisible = thumb;
        /* Track a photo actually assigned to this colour separately from one that is
           merely unassigned. Preferring the assigned one matters: on a product whose
           unassigned shots happen to picture a different colourway, falling back to
           "first visible" put a pink glove on screen while Blue was selected. */
        if (!firstOfColor && owns.indexOf(color) !== -1) firstOfColor = thumb;
      } else {
        hidden++;
      }
    });

    /* If the hero was showing a photo that just got hidden, move it to one that is
       still on screen, otherwise the strip and the main image disagree. */
    var activeStillVisible = Array.prototype.some.call(thumbs, function (t) {
      return !t.hidden && extractBase(t.getAttribute('data-src')) === extractBase(mainImage.src);
    });

    var target = firstOfColor || firstVisible;
    if (!activeStillVisible && target) {
      target.click();
    }

    debug.trace('productGallery:colorFilter', {
      color: color,
      hidden: hidden,
      shown: thumbs.length - hidden
    });
  }

  document.addEventListener('product:variantchange', function (e) {
    if (!e.detail || !e.detail.options) return;
    filterToColor(e.detail.options[colorIndex - 1]);
  });

  /* Apply on load so a variant deep-link arrives already filtered.
     The product lives in the <script data-product-json> block that product-sync.js
     reads; window.theme carries routes and the cart count, never the product. */
  var productJSON = document.querySelector('[data-product-json]');
  if (colorIndex && productJSON) {
    var initial = document.querySelector('[data-variant-id]');
    var variants = [];
    try {
      variants = (JSON.parse(productJSON.textContent) || {}).variants || [];
    } catch (e) {
      debug.trace('productGallery:productJsonParseError', { error: e.message });
    }
    var current = null;
    for (var v = 0; v < variants.length; v++) {
      if (initial && String(variants[v].id) === String(initial.value)) current = variants[v];
    }
    if (current) filterToColor(current.options[colorIndex - 1]);
  }

  debug.trace('productGallery:init', { thumbCount: thumbs.length, colorIndex: colorIndex });
})();
